import React from 'react';
import Toastr from 'toastr';
import Axios from 'axios';
import ApiUrl from '../service/ajax';

Toastr.options ={
    positionClass : 'toast-bottom-right'
}

class Dashboard extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
          fileList: ''
        };
      }

    componentDidMount(){
        Axios.get(ApiUrl + 'tandc/getFiles')
            .then((response) => {
                if(response.data){
                    this.setState({fileList: response.data});
                }
            })
            .catch((error) => {
                Toastr.error(error);
            })
            .finally(() => {
            });
    }

    contains(string, substring) {
        if (!string) {
          return false;
        }
        if (!substring) {
          return true;
        }
        return string.toLowerCase().indexOf(substring.toLowerCase()) !== -1;
    }

    render(){
        const fileList = this.state.fileList || [];
        const links = fileList.map((file,index) => {
                                    let icon = 'fas fa-file icon-default';
                                    if(this.contains(file.Extension,'.pdf')){
                                        icon = 'fas fa-file-pdf icon-red';
                                    }
                                    else if(this.contains(file.Extension,'.doc') || this.contains(file.Extension,'.docx')){
                                        icon = 'fas fa-file-word icon-blue';
                                    }
                                    else if(this.contains(file.Extension,'.xlsx')){
                                        icon = 'fas fa-file-excel icon-green';
                                    }
                                    else if(this.contains(file.Extension,'.txt')){
                                        icon = 'fas fa-file-alt icon-gray';
                                    }
                                    return <div key={index + 1} style={{margin:1}}><span className={icon} style={{marginRight:5}}/><a href={'./' + file.DirectoryName + '/'+ file.FileName + file.Extension} target='_blank'>{file.FileName}</a></div>
                                })
        return (
            <div className='dashboard-container'>
                <div className='card'>
                    <img className='technipfmc-logo' src='./technipfmc-logo.png' alt='TechnipFMC' />
                    <h2 className='title'>Terms and Conditions</h2>
                    <div className='dashboard-content'>
                        <div className='row'>
                            <div className='col-xs-12 col-sm-12'>
                                {links}
                            </div>
                        </div>
                    </div>
                </div>               
            </div>
        );
    }
}

export default Dashboard